/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './activity.tpl.html';
import './audit/AuditItem.js';
import './log/log.tpl.html';

angular
  .module('mobile.activity', ['mobile.activity.audit', 'sbsf.constants'])
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      $stateProvider
        .state(VIEW_STATES.MOBILE_ACTIVITY, {
          abstract: true,
          url: '/mobile/activity',
          views: {
            content: {
              controller: 'MobileActivityCtrl',
              templateUrl: 'mobile/activity/activity.tpl.html'
            }
          },
          resolve: {
            initialLogEntries: [
              'mobileLogFactory',
              function (mobileLogFactory) {
                return mobileLogFactory.loadInitialActivities();
              }
            ]
          }
        })
        .state(VIEW_STATES.MOBILE_ACTIVITY_LOGS, {
          url: '/mobile/activity/logs',
          views: {
            activity: {
              templateUrl: 'mobile/activity/log/log.tpl.html'
            },
            audit: {
              templateUrl: 'mobile/activity/audit/audit.tpl.html'
            }
          }
        })
        .state(VIEW_STATES.MOBILE_AUDIT_ITEM, {
          url: '/mobile/activity/logs/audit',
          views: {
            content: {
              templateUrl: 'mobile/activity/audit/auditItem.tpl.html',
              controller: 'MobileAuditItemCtrl'
            }
          }
        });
    }
  ])
  .controller('MobileActivityCtrl', [
    '$scope',
    'batchUtils',
    'mobileLogFactory',
    '$filter',
    'logFactory',
    'MOBILE_EVENTS',
    '$rootScope',
    'LOG_TYPE',
    'VIEW_STATES',
    '$state',
    function (
      $scope,
      batchUtils,
      mobileLogFactory,
      $filter,
      logFactory,
      MOBILE_EVENTS,
      $rootScope,
      LOG_TYPE,
      VIEW_STATES,
      $state
    ) {
      // Tie the logData used to drive the activity template to the mobileLogFactory logData object.
      $scope.logData = mobileLogFactory.logData;
      // default to the activity view.
      $scope.viewInfo = mobileLogFactory.viewInfo;
      // Not currently loading.
      $scope.activitiesBusy = false;
      // Object used to track if a load should be executed for each log type.  Note the properties of
      // this object are used as the alternate trigger on the infinite scroller.
      $scope.loadMore = {
        activities: false,
        audits: false
      };

      /**
       * Handler used to togger the mode between activity and audit.
       */
      $scope.changeMode = function () {
        mobileLogFactory.changeLog();
      };

      /**
       * Callback handler for the infinite scroll directive used to load another page
       * of activity events.
       */
      $scope.loadActivities = function () {
        if ($scope.activitiesBusy) {
          return;
        }
        $scope.activitiesBusy = true;
        $scope.loadMore.activities = false;

        mobileLogFactory.loadActivities().then(function () {
          $scope.activitiesBusy = false;
        });
      };

      /**
       * Callback handler for the infinite scroll directive used to load another page
       * of audit events.
       */
      $scope.loadAudits = function () {
        if ($scope.activitiesBusy) {
          return;
        }
        $scope.activitiesBusy = true;
        $scope.loadMore.audits = false;

        mobileLogFactory.loadAudits().then(function () {
          $scope.activitiesBusy = false;
        });
      };

      /**
       * Provides the html to be rendered for an activity.
       *
       * @param {object} action - A batch object.
       * @returns {string} - The html to be rendered for the activity row.
       */
      $scope.getMessage = function (action) {
        return $filter('mobileBatchMessage')(action);
      };

      /**
       * Provides the html content to be used for an audit event.
       *
       * @param {object} audit - An audit event.
       * @returns {string} - The html to be rended for the event.
       */
      $scope.getAuditMessage = function (audit) {
        return logFactory.getEventType(audit);
      };

      /**
       * Returns the date string.
       * @param {object} audit - The audit item.
       * @returns {string} - The string to display.
       */
      $scope.getAuditDate = function (audit) {
        return $filter('shortHumanizeFilter')(audit.date);
      };

      /**
       * Handler for the load more button.
       */
      $scope.triggerLoad = function () {
        if ($scope.viewInfo.logView === LOG_TYPE.ACTIVITY) {
          $scope.loadActivities();
        } else {
          $scope.loadAudits();
        }
      };

      /**
       * Function that determines if the loading indicator should be shown.  It should
       * show if there is currently a load in progress or if there are no more items
       * to be loaded.
       *
       * @param {string} logType - The log view that is asking.
       * @returns {boolean} - true to show the loading indicator.
       */
      $scope.showLoadingIndicator = function (logType) {
        var loading, total, len, noItems;

        if (logType === LOG_TYPE.ACTIVITY) {
          total = $scope.logData.activities.total;
          len = $scope.logData.activities.items.length;
        } else {
          total = $scope.logData.audits.total;
          len = $scope.logData.audits.items.length;
        }

        loading = $scope.activitiesBusy || len === total;
        noItems = total === 0;
        return loading && $scope.viewInfo.logView === logType && !noItems;
      };

      /**
       * Provides boolean that indicates if the sleepy cloud should be displayed.
       *
       * @returns {boolean} - True to display the no items sleepy cloud, false otherwise.
       */
      $scope.showSleepy = function () {
        return (
          ($scope.logData.activities.total === 0 && $scope.viewInfo.logView === LOG_TYPE.ACTIVITY) ||
          ($scope.logData.audits.total === 0 && $scope.viewInfo.logView === LOG_TYPE.AUDIT)
        );
      };

      /**
       * Function for providing the text displayed when no items exist.
       *
       * @returns {string} - The text to be displayed where then are no items.
       */
      $scope.getSleepyText = function () {
        return $scope.viewInfo.logView === LOG_TYPE.ACTIVITY
          ? $filter('i18n')('NO_ACTIVITY')
          : $filter('i18n')('NO_CHANGES');
      };

      /**
       * Audit item click handler.  Used to navigate to an audit item view.
       *
       * @param {number} id - The id of the audit item to view.
       */
      $scope.goToAuditItem = function (id) {
        mobileLogFactory.setCurrentAuditItem(id);
        // Firing this event triggers the header update for navigating back
        // to the current state.
        $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
          title: $filter('i18n')('DETAILS'),
          previous: VIEW_STATES.MOBILE_ACTIVITY_LOGS
        });
        $state.go(VIEW_STATES.MOBILE_AUDIT_ITEM);
      };

      /**
       * Activity item click handler.  Used to navigate to an activity item view.
       *
       * @param {object} selectedBatch - The selected batch of the activity item to view.
       */
      $scope.goToActivityItem = function (selectedBatch) {
        batchUtils.currentBatch = selectedBatch;
        var batchDate = batchUtils.getTitleBatchDate();
        $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
          title: batchDate,
          previous: VIEW_STATES.MOBILE_ACTIVITY_LOGS
        });
        if (selectedBatch.type === 'EXPORT' || selectedBatch.type === 'BULK_RESTORE_PREVIEW') {
          $state.go(VIEW_STATES.MOBILE_BATCH_EXPORT);
        } else if (selectedBatch.type === 'OBJECT_RESTORE') {
          $state.go(VIEW_STATES.MOBILE_BATCH_OBJECT_RESTORE);
        } else if (selectedBatch.type === 'BULK_RESTORE') {
          $state.go(VIEW_STATES.MOBILE_BATCH_BULK_RESTORE);
        } else {
          $state.go(VIEW_STATES.MOBILE_BATCH_HOME);
        }
      };

      /**
       * Add a listener for the header refresh event indicating that the refresh icon in the
       * header was clicked.  When that happens call the refresh function on the mobileLogFactory.
       */
      $rootScope.$on(MOBILE_EVENTS.HEADER_REFRESH, function () {
        mobileLogFactory.refresh();
      });
    }
  ]);
